<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-05-19 17:02:34
 * @LastEditTime: 2021-06-18 19:00:19
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button v-action:add @click="handleCreate" class="mr-4" type="primary" icon="plus">
        新增试题
      </a-button>
      <go-back />
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <div class="ant-pro-page-header-search">
          <a-input-search
            size="large"
            style="width: 80%; max-width: 522px;"
            v-model="params.where.title"
            placeholder="请输入名称"
            enter-button
            @search="getLists()"
          />
        </div>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false">
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="operation" slot-scope="text, record">
          <a-button v-action:update @click="handleEdit(record.id)" type="link" size="small">编辑</a-button>
          <a-popconfirm
            title="确定要删除该信息吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleOnDelete(record.id)"
            v-action:delete
          >
            <a-button type="link" size="small">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入
import { GoBack } from '@/components/'
import ModelForm from './modules/ModelForm'

const apiList = {
    changeState: '/exams/',
    create: '/exams/papers/create',
    update: '/exams/papers/',
    delete: '/exams/papers/'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '题目',
        dataIndex: 'question'
    },
    {
        title: '答案',
        dataIndex: 'correct'
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '更新时间',
        dataIndex: 'updated_at',
        sorter: true
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'PracticeList',
    mixins: [list, table, select], // 使用mixins
    components: {
        GoBack,
        ModelForm
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.apiList.getList = '/exams/' + this.$route.params.id + '/papers'
        this.getLists() // 获取列表
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-05-20 12:28:22
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:弹窗添加试题
         * @param  {*}
         * @return {*}
         */
        handleCreate () {
            const that = this
            that.$dialog(
                ModelForm,
                // component props
                {
                    pid: this.$route.params.id,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                // modal props
                {
                    title: '添加试题',
                    centered: true,
                    width: 700,
                    maskClosable: true,
                    okText: '提交',
                    cancelText: '关闭'
                }
            )
        },
        handleEdit (id) {
            const that = this
            that.$dialog(
                ModelForm,
                // component props
                {
                    id,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                // modal props
                {
                    title: '编辑试题',
                    centered: true,
                    width: 700,
                    maskClosable: true,
                    okText: '提交',
                    cancelText: '关闭'
                }
            )
        }
    }
}
</script>
